<template>
  <div class="incenters">
    <div style="">
      <Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="update" :src="require('@/assets/icon/icon-add.png')">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px" @btnclick="update" :src="require('@/assets/icon/icon-update.png')">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="update" :src="require('@/assets/icon/icon-del.png')">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" title="保存" fontSize="14px" @btnclick="deactivate" :src="require('@/assets/icon/bc.png')">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" title="取消" fontSize="14px" @btnclick="deactivate" :src="require('@/assets/icon/qux.png')">
      </Commonbtn>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div style="width: 980px;">
      <div class="bottom">
        <div class="left">
          <div style="margin: 20px;">
            <el-tree :data="datas" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
          </div>
        </div>
        <div class="right">
          <div style="margin: 10px;">
            <template v-for="(item , index) of fromdataadd">
              <Commondropdownlist :key="index" :options="item.options" :btx="item.btx" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled">
              </Commondropdownlist>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 40px;">
    </div>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条指标吗？</span>
    </Dialog>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate" @dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用这条档案吗？</span>
    </Dialog>
  </div>
</template>
<script>
import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
import Commontable from '../../../../components/common-table.vue'
import Commonbtn from '../../../../components/common-btn.vue'
import Pagination from '../../../../components/pagination.vue'
import DialogFrom from '../../../../components/dialog-from.vue'
import fromdata from '../fromData/add'
import fromdataedit from '../fromData/edit'
import fromdataquarter from '../fromData/quarter'
import fromdataquarterdeit from '../fromData/quarterdeit'
import Dialog from '../../../../components/dialog.vue'
import Commondown from '../../../../components/common-down.vue'
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    DialogFrom,
    Commondropdownlist,
    Dialog,
    Commondown
  },
  data: function () {
    return {
      dialogVisibles: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      dialogVisibledeactivate: false,
      dialogVisiblesU8: false,
      dialogVisiblesU8d: false,
      rightboo: false,
      dwonleft: false,
      username: '',
      name: '',
      ptype: '',
      fromdataadd: [],
      fromdataedit: [],
      fromdataquarter: [],
      fromdataquarterdeit: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      datas: [{
        label: '一级 1',
        children: [{
          label: '二级 1-1',
          children: [{
            label: '三级 1-1-1'
          }]
        }]
      }, {
        label: '一级 2',
        children: [{
          label: '二级 2-1',
          children: [{
            label: '三级 2-1-1'
          }]
        }, {
          label: '二级 2-2',
          children: [{
            label: '三级 2-2-1'
          }]
        }]
      }, {
        label: '一级 3',
        children: [{
          label: '二级 3-1',
          children: [{
            label: '三级 3-1-1'
          }]
        }, {
          label: '二级 3-2',
          children: [{
            label: '三级 3-2-1'
          }]
        }]
      }],
      tableData: [{
        id: '1',
        indicatortype: '102100024',
        customername: 'TGC055-05-115',
        hospitalname: '归创',
        productline: '460',
        year: '上海延新贸易中心',
        januaryindicators: '21A01834',

      },
      {
        id: '2',
        indicatortype: '102100024',
        customername: 'TGC055-05-115',
        hospitalname: '归创',
        productline: '460',
        year: '上海延新贸易中心',
        januaryindicators: '21A01834'
      },
      {
        id: '3',
        indicatortype: '102100024',
        customername: 'TGC055-05-115',
        hospitalname: '归创',
        productline: '460',
        year: '上海延新贸易中心',
        januaryindicators: '21A01834'
      },
      ],
      headerData: [{
        prop: 'id',
        label: '序号',
        columnwidth: 80,

      },
      {

        prop: 'indicatortype',
        label: '指标类型',
        columnwidth: 120
      },
      {
        prop: 'customername',
        label: '客户名称',
        columnwidth: 180
      },
      {
        prop: 'hospitalname',
        label: '医院名称',
        columnwidth: 120
      },
      {
        prop: 'productline',
        label: '产品线',
        columnwidth: 120
      },
      {
        prop: 'year',
        label: '年度',
        columnwidth: 214
      },
      {
        prop: 'januaryindicators',
        label: '1月指标',
        columnwidth: 130
      }
      ],
      tableData1: [{
        kong: '',
        U8id: '1',
        U8number: '102100024',
      },
      {
        kong: '',
        U8id: '2',
        U8number: '102100024',
      },
      {
        kong: '',
        U8id: '3',
        U8number: '102100024',
      },
      ],
      headerData1: [{
        prop: 'kong',
        columnwidth: 39,
        types: 'selection'

      },
      {
        prop: 'U8id',
        label: 'U8账套',
        columnwidth: 400,

      },
      {

        prop: 'U8number',
        label: 'U8编号',
        columnwidth: 522
      },
      ],
      downlist: [{
        title: '新增采购指标'
      },
      {
        title: '新增销售指标'
      },
      ],
      downlistdel: [{
        title: '删除选中项'
      },
      {
        title: '全部删除'
      },
      ],
      qus: [],
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false,
        submit: false,
        skip: false,//跳过
        reset: false, //重置
        setting: false
      },
    }
  },
  mounted() {
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
    this.fromdataquarter = JSON.parse(JSON.stringify(fromdataquarter))
    this.fromdataquarterdeit = JSON.parse(JSON.stringify(fromdataquarterdeit))
    let data = JSON.parse(localStorage.getItem("MenusData"))
    let MenuID = this.$route.query.MenuID
    //console.log(data.Menus[0].Nodes[2], "data")
    data.Menus[0].Nodes[2].Nodes.map((item, index) => {
      if (item.NodeID == MenuID) {
        this.qus = item.Nodes
      }
    })
    if (this.qus) {
      this.qus.map((item, index) => {
        if (item.NodeName == 'add') {
          this.qx.add = true
        } else if (item.NodeName == 'edit') {
          this.qx.update = true
        } else if (item.NodeName == 'delete') {
          this.qx.del = true
        } else if (item.NodeName == 'stopif') {
          this.qx.del = true
        } else if (item.NodeName == 'assignment') {
          this.qx.assignment = true
        } else if (item.NodeName == 'enabled') {
          this.qx.enabled = true
        } else if (item.NodeName == 'skip') {
          this.qx.skip = true
        } else if (item.NodeName == 'reset') {
          this.qx.reset = true
        } else if (item.NodeName == 'setting') {
          this.qx.setting = true
        }
      })
    }
    //console.log("qux", this.qus)
    //console.log(this.fromdataedit, 'sadasdasdasdasdsadsad')
  },
  methods: {
    commclick(type) {
      this[type] = true
    },
    // commcancelclick(type){
    // 	this[type] = false
    // },
    // commdialogOKclick(type){
    // 	this[type] = false
    // },
    adduser() {
      this.dialogVisibles = true
      //console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      this.dialogVisibles = false
    },
    update() {
      this.dialogVisiblesedit = true
    },
    canceledit() {
      this.dialogVisiblesedit = false
    },
    dialogOKedit() {
      this.dialogVisiblesedit = false
    },
    downsdel(index) {
      if (index == 0) {
        this.dialogVisibledel = true
      }
    },
    canceldel() {
      this.dialogVisibledel = false
    },
    dialogOKdel() {
      this.dialogVisibledel = false
    },
    deactivate() {
      this.dialogVisibledeactivate = true
    },
    canceldeactivate() {
      this.dialogVisibledeactivate = false
    },
    dialogOKdeactivate() {
      this.dialogVisibledeactivate = false
    },
    downs(index) {
      //console.log("index", index)
      if (index == 0) {
        this.dialogVisibles = true
      }
      if (index == 1) {
        this.dialogVisiblesU8d = true
      }
    },
    cancelU8() {
      this.dialogVisiblesU8 = false
    },
    dialogOKeditU8() {
      this.dialogVisiblesU8 = false
    },
    cancelU8d() {
      this.dialogVisiblesU8d = false
    },
    dialogOKeditU8d() {
      this.dialogVisiblesU8d = false
    },
    handleNodeClick(data) {
      //console.log(data);
    }
  }
}
</script>

<style lang="less" scoped>
.incenters {
  height: 100%;

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    padding-bottom: 16px;
  }

  // div {
  //   margin-left: 8px;
  //   margin-right: 8px;
  //   margin-top: 5px;
  //   margin-bottom: 5px;

  // }
  .from {
    width: 100%;
  }

  .signingroles {
    height: 500px;
    width: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // border: 1px solid red;

    .left {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
    }

    .right {
      height: 240px;
      width: 470px;
      border: 1px solid #e6e6e6;
      // pointer-events: none;
    }
  }
}

.right-s {
  position: absolute;
  z-index: 99;
  opacity: 0.5;
  right: 21px;
  width: 470px;
  height: 240px;
  background-color: #ffffff;
  cursor: no-drop;
}

.dwonleft {
  width: 170px;
  height: 48px;
  position: absolute;
  background-color: #ffffff;
  z-index: 99;
  right: 350px;
  top: 322px;
  text-align: center;
  line-height: 48px;
  color: #333333;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}

.dwonleft:hover {
  background-color: #f0f0f0;
}

.dialogstyle {
  width: 952px;
  height: 100px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  margin-top: 10px;
}

.bottom {
  display: flex;
  justify-content: space-around;
  align-items: center;

  .left {
    width: 465px;
    height: 533px;
    background: #ffffff;
    border: 1px solid #e6e6e6;
  }

  .right {
    width: 465px;
    height: 533px;
    background: #ffffff;
    border: 1px solid #e6e6e6;
  }
}
</style>
